module.exports = "/_next/static/images/ff761b91150ac1021ab5cdbf264c4b11-currency.svg.webp";